import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { ToastContext } from "../../../../hooks/context";
import { exportCustomers } from "../../../../services/customer";
import { formatDateYYYYMMDD } from "../../../../helpers";

export const useCustomersExport = ({
  closeWidget,
  currentStore = "",
  searchParams = null,
}) => {
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const triggerToast = useContext(ToastContext);

  const [selectedStore, setSelectedStore] = useState(currentStore || "");
  const [startDate, setStartDate] = useState(
    searchParams?.get?.("start_date") || "",
  );
  const [endDate, setEndDate] = useState(searchParams?.get?.("end_date") || "");
  const [dobDay, setDobDay] = useState("");
  const [dobMonth, setDobMonth] = useState("");
  const [dobYear, setDobYear] = useState("");
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async (e) => {
    e?.preventDefault?.();
    setIsExporting(true);

    const formattedStartDate = startDate ? formatDateYYYYMMDD(startDate) : "";
    const formattedEndDate = endDate ? formatDateYYYYMMDD(endDate) : "";

    const payload = {
      ...(selectedStore && { store_id: selectedStore }),
      ...(formattedStartDate && { start_date: formattedStartDate }),
      ...(formattedEndDate && { end_date: formattedEndDate }),
      ...(dobDay && { birthday_day: String(dobDay) }),
      ...(dobMonth && { birthday_month: String(dobMonth) }),
      ...(dobYear && { birthday_year: String(dobYear) }),
    };

    exportCustomers(payload)
      .then((res) => {
        const downloadUrl =
          res?.data?.data?.url ||
          (typeof res?.data === "string" && res?.data?.startsWith("http")
            ? res.data
            : null);

        if (downloadUrl) window.open(downloadUrl, "customers_export");

        triggerToast(
          res?.data?.detail ||
            res?.data?.message ||
            "Customer data export generated successfully",
          "success",
        );
        setIsExporting(false);
        closeWidget();
      })
      .catch(() => {
        setIsExporting(false);
      });
  };

  return {
    selectedStore,
    setSelectedStore,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    dobDay,
    setDobDay,
    dobMonth,
    setDobMonth,
    dobYear,
    setDobYear,
    isExporting,
    storeList: storeList || [],
    handleExport,
  };
};

export default useCustomersExport;
